import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

function sortInfoHovered() {
    SnowplowService.fireStructuredEventWithBatchId({
        action: 'hover',
        category: 'react_search',
        label: 'sort_by_info',
    });

    amplitude.track('sort_by_info hovered');
}

export default { sortInfoHovered };
